import React from "react"
import { createMemoryHistory } from "history"
import { Route, Router, Switch } from "react-router-dom"

import "assets/scss/material-kit-react.scss?v=1.4.0"
import "typeface-roboto"
import "typeface-roboto-slab"

// pages for this product
import LandingPage from "./LandingPage/LandingPage.jsx"

import { Helmet } from "react-helmet"

let hist = createMemoryHistory()

export default () => (
  <div>
    <Helmet>
      <title>Privasee</title>
      <script
        type="text/javascript"
        src="//downloads.mailchimp.com/js/signup-forms/popup/unique-methods/embed.js"
        data-dojo-config="usePlainJson: true, isDebug: false"
      />
    </Helmet>
    <Router history={hist}>
      <div>
        <Switch>
          <Route path="/" component={LandingPage} />
        </Switch>
      </div>
    </Router>
  </div>
)
